import React from 'react'
import styles from './Container.module.scss'

const Container = ({
  as: Element = 'div',
  children,
  className = '',
  width = 'standard',
}) => (
  <Element className={`${styles.container} ${styles[width] || ''} ${className}`.trim()}>
    {children}
  </Element>
)

export default Container
